module.exports = fox._r("images/slides/slide_1_2.jpg", __webpack_public_path__ + "images/slides/slide_1_2.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/slide_1_2.jpg
// module id = 505
// module chunks = 2